const storagePrefix = import.meta.env.VITE_APP_NAME;

const getConfigStorageItem = (key: string) => {
 const item = localStorage.getItem(`${storagePrefix}_${key}`);
 return item ? JSON.parse(item) : 'null';
};

const setConfigStorageItem = ({
 page,
 key,
 value,
}: {
 page?: string;
 key: string;
 value: string | object;
}) => {
 const currentValue = getConfigStorageItem(`${page}`);

 localStorage.setItem(
  `${storagePrefix}_${page}`,
  typeof value === 'object'
   ? JSON.stringify({ ...currentValue, [key]: value })
   : value,
 );
};

const removeConfigStorageItem = ({
 page,
 key,
}: {
 page?: string;
 key: string;
}) => {
 const currentValue = getConfigStorageItem(page ? `${page}_${key}` : key);
 const newCurrentValue = Object.keys(currentValue || {}).filter(
  (item) => item !== key,
 );
 localStorage.setItem(
  `${storagePrefix}_${page}`,
  JSON.stringify(newCurrentValue),
 );
};

export { getConfigStorageItem, removeConfigStorageItem, setConfigStorageItem };
